export function Brand({ size = "default" }: { size?: "default" | "lg" }) {
  return <span className="inline-flex shrink-0 items-center gap-2.5">
    <img src="/nexra-mark.svg" width={size === "lg" ? 57.6 : 32} height={size === "lg" ? 57.6 : 32} alt="" />
    <span className={size === "lg" ? "text-4xl font-semibold tracking-tight text-foreground" : "text-xl font-semibold tracking-tight text-foreground max-[420px]:hidden"}>nexra</span>
  </span>;
}
